"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var domEvents_1 = require("../../../mixins/domEvents");
var Container_1 = require("../../Container");
var ElementTag_1 = __importDefault(require("../ElementTag"));
var SwitchContext_1 = __importStar(require("./SwitchContext"));
var Input = domEvents_1.focuseable(function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'input' : _b, rest = __rest(_a, ["as"]);
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as }, rest)));
});
var SwitchBase = function (props) {
    var ariaId = props.ariaId, disabled = props.disabled, className = props.className, checkedProp = props.checked, name = props.name, value = props.value, required = props.required, inputType = props.inputType, onChange = props.onChange, onChanging = props.onChanging, children = props.children, rest = __rest(props, ["ariaId", "disabled", "className", "checked", "name", "value", "required", "inputType", "onChange", "onChanging", "children"]);
    var context = SwitchContext_1.useInitializeContext({
        ariaId: ariaId,
        checked: checkedProp,
        onChange: onChange,
        onChanging: onChanging
    });
    var checked = context.checked, changeChecked = context.changeChecked;
    return (react_1["default"].createElement(SwitchContext_1["default"].Provider, { value: context },
        react_1["default"].createElement(Container_1.Container, __assign({ className: [disabled && 'disabled', checked && 'selected', className] }, rest),
            react_1["default"].createElement(Input, { id: ariaId, type: inputType, required: required, checked: !!checked, disabled: disabled, onChange: function (event) {
                    return changeChecked(event.target.checked);
                }, value: value, name: name }),
            children)));
};
exports["default"] = SwitchBase;
//# sourceMappingURL=SwitchBase.js.map